import React from "react";
import AccessControlManagement from "../../components/AccessControl/control";

const AccessControl = () => {
    return (
        <div>

            <AccessControlManagement />
        </div>
    )

}
export default AccessControl;